module.exports = "<div class=\"image-container\">\n    <img [src]=\"media.url | urlEncode\"/>\n</div>\n"